module.exports = __webpack_public_path__ + "img/MASCARELLO.92a91bd9.svg";